import React from 'react';

export const DownloadDocument = ({ handleOnStartFileDownload, precontractualLinks }) => {
    return (
        <>
            <a id="downloadPdf" className="hidden" />
            <a
                href="#"
                onClick={event => {
                    event.preventDefault();
                    handleOnStartFileDownload(precontractualLinks);
                }}
                data-testid="download-document"
            >
                <i className="icons icons--icon-download" />
            </a>
        </>
    );
};
